import { useLazyQuery } from '@apollo/client';
import { GET_FACEBOOK_PAGES } from 'api/social-media-connections/queries';
import {
  GetFacebookPages,
  GetFacebookPagesVariables,
} from 'api/social-media-connections/types/GetFacebookPages';

export const useGetFacebookPages = () => {
  return useLazyQuery<GetFacebookPages, GetFacebookPagesVariables>(
    GET_FACEBOOK_PAGES
  );
};
